import { useParams } from 'react-router-dom';

import { RoleFormPage } from '@personnel/presentation/components/shared';

interface RoleDuplicateParams {
  uuid: string;
}

/**
 * Role Duplicate Page
 *
 * Page for duplicating an existing role.
 * Wrapper component that delegates to RoleFormPage with mode='duplicate'.
 * Route: /roles/:uuid/duplicate
 *
 * @returns {React.ReactElement} Role duplicate page component
 *
 * @example
 * // In router
 * <Route path="/roles/:uuid/duplicate" component={RoleDuplicatePage} />
 */
export const RoleDuplicatePage = (): React.ReactElement => {
  const { uuid } = useParams<RoleDuplicateParams>();

  return <RoleFormPage mode="duplicate" roleUuid={uuid} />;
};
